// extracted by mini-css-extract-plugin
export default {"fade":"Spinner_fade__+DKiF","container":"Spinner_container__kdpnf"};